import {IconExtendedSize, IconSize, iconStrokeWidthBySize} from '../icon_types';

type CameraIconProps = {
  id?: string;
  className?: string;
  size: IconSize | IconExtendedSize;
  color?: string;
};

const pathDsBySize = {
  '6': [
    'M5.75 4.75C5.75 4.88261 5.69732 5.00979 5.60355 5.10355C5.50979 5.19732 5.38261 5.25 5.25 5.25H0.75C0.617392 5.25 0.490215 5.19732 0.396447 5.10355C0.302678 5.00979 0.25 4.88261 0.25 4.75V2C0.25 1.86739 0.302678 1.74021 0.396447 1.64645C0.490215 1.55268 0.617392 1.5 0.75 1.5H1.75L2.25 0.75H3.75L4.25 1.5H5.25C5.38261 1.5 5.50979 1.55268 5.60355 1.64645C5.69732 1.74021 5.75 1.86739 5.75 2V4.75Z',
    'M3 4.25C3.55228 4.25 4 3.80228 4 3.25C4 2.69772 3.55228 2.25 3 2.25C2.44772 2.25 2 2.69772 2 3.25C2 3.80228 2.44772 4.25 3 4.25Z',
  ],
  '8': [
    'M7.66683 6.33333C7.66683 6.51014 7.59659 6.67971 7.47157 6.80474C7.34654 6.92976 7.17697 7 7.00016 7H1.00016C0.823352 7 0.653783 6.92976 0.528758 6.80474C0.403734 6.67971 0.333496 6.51014 0.333496 6.33333V2.66667C0.333496 2.48986 0.403734 2.32029 0.528758 2.19526C0.653783 2.07024 0.823352 2 1.00016 2H2.3335L3.00016 1H5.00016L5.66683 2H7.00016C7.17697 2 7.34654 2.07024 7.47157 2.19526C7.59659 2.32029 7.66683 2.48986 7.66683 2.66667V6.33333Z',
    'M3.99984 5.66667C4.73622 5.66667 5.33317 5.06971 5.33317 4.33333C5.33317 3.59695 4.73622 3 3.99984 3C3.26346 3 2.6665 3.59695 2.6665 4.33333C2.6665 5.06971 3.26346 5.66667 3.99984 5.66667Z',
  ],
  '12': [
    'M11.5 9.5C11.5 9.76522 11.3946 10.0196 11.2071 10.2071C11.0196 10.3946 10.7652 10.5 10.5 10.5H1.5C1.23478 10.5 0.98043 10.3946 0.792893 10.2071C0.605357 10.0196 0.5 9.76522 0.5 9.5V4C0.5 3.73478 0.605357 3.48043 0.792893 3.29289C0.98043 3.10536 1.23478 3 1.5 3H3.5L4.5 1.5H7.5L8.5 3H10.5C10.7652 3 11.0196 3.10536 11.2071 3.29289C11.3946 3.48043 11.5 3.73478 11.5 4V9.5Z',
    'M6 8.5C7.10457 8.5 8 7.60457 8 6.5C8 5.39543 7.10457 4.5 6 4.5C4.89543 4.5 4 5.39543 4 6.5C4 7.60457 4.89543 8.5 6 8.5Z"',
  ],
  '16': [
    'M15.3332 12.6667C15.3332 13.0203 15.1927 13.3594 14.9426 13.6095C14.6926 13.8595 14.3535 14 13.9998 14H1.99984C1.64622 14 1.30708 13.8595 1.05703 13.6095C0.80698 13.3594 0.666504 13.0203 0.666504 12.6667V5.33333C0.666504 4.97971 0.80698 4.64057 1.05703 4.39052C1.30708 4.14048 1.64622 4 1.99984 4H4.6665L5.99984 2H9.99984L11.3332 4H13.9998C14.3535 4 14.6926 4.14048 14.9426 4.39052C15.1927 4.64057 15.3332 4.97971 15.3332 5.33333V12.6667Z',
    'M8.00016 11.3333C9.47292 11.3333 10.6668 10.1394 10.6668 8.66667C10.6668 7.19391 9.47292 6 8.00016 6C6.5274 6 5.3335 7.19391 5.3335 8.66667C5.3335 10.1394 6.5274 11.3333 8.00016 11.3333Z',
  ],
  '24': [
    'M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z',
    'M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z',
  ],
  '32': [
    'M30.6668 25.3333C30.6668 26.0406 30.3859 26.7189 29.8858 27.219C29.3857 27.719 28.7074 28 28.0002 28H4.00016C3.29292 28 2.61464 27.719 2.11454 27.219C1.61445 26.7189 1.3335 26.0406 1.3335 25.3333V10.6667C1.3335 9.95942 1.61445 9.28115 2.11454 8.78105C2.61464 8.28095 3.29292 8 4.00016 8H9.3335L12.0002 4H20.0002L22.6668 8H28.0002C28.7074 8 29.3857 8.28095 29.8858 8.78105C30.3859 9.28115 30.6668 9.95942 30.6668 10.6667V25.3333Z',
    'M15.9998 22.6667C18.9454 22.6667 21.3332 20.2789 21.3332 17.3333C21.3332 14.3878 18.9454 12 15.9998 12C13.0543 12 10.6665 14.3878 10.6665 17.3333C10.6665 20.2789 13.0543 22.6667 15.9998 22.6667Z',
  ],
};

const CameraIcon = (props: CameraIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default CameraIcon;
